import React from 'react';
import { useInvoice } from '../context/InvoiceContext';

const Notification = () => {
  const { notification } = useInvoice();

  if (!notification) return null;

  const typeClass = {
    success: 'alert-success',
    error: 'alert-error',
    warning: 'alert-warning',
    info: 'alert-info'
  }[notification.type] || 'alert-info';

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        maxWidth: '400px',
        animation: 'slideIn 0.3s ease-out'
      }}
    >
      <div className={`alert ${typeClass}`}>
        <span>{notification.message}</span>
      </div>
    </div>
  );
};

export default Notification;
